import React from "react";

import { SkeletonList, type SkeletonListProps } from "~/components/skeleton/list";
import { TableStickyCells } from "~/components/table/sticky-cells";
import { drop } from "~/tools/drop";
import { take } from "~/tools/take";

export interface FixedColumnsProps<T> extends Omit<SkeletonListProps<T>, "children"> {
	fixedColumns: undefined | number;
	children: (column: undefined | T) => React.ReactElement;
}

export function FixedColumns<T>({
	fixedColumns = 0,
	each,
	children,
	...props
}: FixedColumnsProps<T>): React.ReactElement {
	return (
		<>
			{fixedColumns > 0 && each != null && (
				<TableStickyCells span={fixedColumns}>
					{take(each, fixedColumns).map((column) => children(column))}
				</TableStickyCells>
			)}

			<SkeletonList each={each == null ? undefined : drop(each, fixedColumns)} {...props}>
				{children}
			</SkeletonList>
		</>
	);
}
